import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { EventService } from "../services/event-service";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { LocalCacheService } from "../services/local-cache-service";
import { ContractService } from "../services/contract-service";
import { IdBuilder } from "../ts/rlAdmin.utils";

export function RLEntitySummaryNav() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-summary-nav.html"),
        scope: {
            entity: "=?",
            entityId: "@?",
            entityNoun: "@"
        },
        bindToController: {
            visibility: "=",
            isValid: "=?",
            isDeletable: "=?",
            callback: "&?"
        },
        transclude: true,
        controllerAs: "esnVM",
        controller: RLEntitySummaryNavController
    };
    return directive;
}

interface IRLEntitySummaryNavScope extends ng.IScope {
    entity: Models.IEntity;
    entityId: string;
    entityNoun: string;
    callback: () => ng.IPromise<any>;
    isValid: boolean;
    visibility: number;
}

class RLEntitySummaryNavController {

    static $inject = ["$scope", "$q", "localCacheService", "entityService", "notifyService", "eventService", "contractService", "$timeout"];

    displayValues: { title: string; value: string }[];
    initialized: boolean;
    isValid: boolean;

    entityRecord: Models.IEntity = null;
    entityId: string;

    callback: () => ng.IPromise<any>;

    entityNoun: string;

    validationModalOpen: boolean = false;
    validationResults: Models.IValidationResult = null;
    wasValidated: boolean = false;
    isLocked: boolean = true;
    visibility: number;
	isDeletable: boolean = false;

	validatePromise: ng.IPromise<any> = null;

    get showWorkflowActions(): boolean {
        return this.entityRecord != null && this.isValid;
    }

    constructor(private $scope: IRLEntitySummaryNavScope,
        private $q: ng.IQService,
        private localCacheService: LocalCacheService,
        private entityService: EntityService,
        private notifyService: NotifyService,
		private eventService: EventService,
		private contractService: ContractService,
        private $timeout: ng.ITimeoutService) {
        this.initialized = false;
        this.displayValues = [];
        this.isValid = false;
        this.entityNoun = $scope.entityNoun;

        if (!_.isNull($scope.entityId) && !_.isEmpty($scope.entityId)) {
            this.LoadEntity($scope.entityId);
        } else {
            $scope.$watch<Models.IEntity>("entity", (newValue, oldValue) => {
                if (newValue != null) {
                    this.entityRecord = newValue;
                    this.entityId = newValue.id;
                }
            });
        }

        $scope.$watch(() => this.entityRecord,
            (newValue, oldValue) => {
                if (newValue != oldValue || (newValue != null && !this.initialized)) {
                    this.SetupValues(newValue);

                    if (!this.wasValidated) {
						this.Validate();
                    }
                }
            }, true);

        $scope.$watch(() => {
            if (this.entityRecord == null) {
                return null;
            } else {
                return this.entityRecord.id;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.LoadEntity(this.entityRecord.id);
                    });
                }
            });


        var tryValidation = () => {
            if (_.isEmpty(this.entityId)) {
                this.$timeout(() => { tryValidation() }, 1000);
                return this.$q.when(null);
            } else {
                return this.Validate();
            }
        }

        eventService.on(Consts.Events.ValidateEntity, () => tryValidation());
    }

    InvokeCallback(): ng.IPromise<any> {

        var ret: ng.IPromise<void> = (this.callback != null)
            ? this.callback()
            : this.$q.resolve();

        return ret;
    }

    LoadEntity(entityID: string) {
        this.notifyService.startProgress();
        this.entityService.getEntityRecord(entityID)
            .then((result) => {
                this.entityRecord = result;
                this.entityId = result.id;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SetupValues(entity: Models.IEntity) {

        this.displayValues = [];

        if ((entity.charTypeID == Consts.CharTypeIDs.transaction || entity.charTypeID == Consts.CharTypeIDs.project) &&
            entity.recordRevisionID > 0) {

            this.displayValues.push({ title: "ID", value: entity.recordID + "-" + entity.recordRevisionID });
        } else {
            this.displayValues.push({ title: "ID", value: entity.recordID.toString() });
        }

        this.displayValues.push({ title: "Template", value: entity.template });
        this.initialized = true;
    }

    ShowValidation() {
        this.validationModalOpen = true;
    }

	Validate(): ng.IPromise<any> {
        this.notifyService.startProgress();
        var entityId: string = ((this.entityRecord != null) && (this.entityRecord.id != null)) ? this.entityRecord.id : this.$scope.entityId;

        if (_.isEmpty(entityId)) {
            return this.$q.when(null);
        }

        var visibility: number = this.visibility != null ? this.visibility : this.$scope.visibility;

        var cacheKey = `validate_${entityId}`;
        return this.localCacheService.getCachedOrDoCachePromise(cacheKey, () => this.entityService.validateEntity(entityId, visibility), moment.duration(5, 'seconds'))
            .then((results) => {
                this.$scope.isValid = results.isValid;
                this.isValid = results.isValid;
                this.validationResults = results;
                this.isLocked = results.isLocked;
                this.isDeletable = results.isDeletable;
            })
            .finally(() => {
                this.wasValidated = true;
                this.notifyService.endProgress();
            });
	}	
}